<template>
	<div class="dropdown cart-dropdown">
		<nuxt-link
			to="/shop/cart"
			class="dropdown-toggle"
		>
			<i class="icon-shopping-cart"></i>
			<span class="cart-count">{{ cartStore.qtyTotal }}</span>
			<span class="cart-txt">R{{ cartStore.priceTotal.toFixed(2) }}</span>
		</nuxt-link>

		<div
			class="dropdown-menu dropdown-menu-right"
			v-if="cartStore.cartList.length > 0"
			key="hasCart"
		>
			<div class="dropdown-cart-products">
				<div
					class="product"
					v-for="(product, index) in cartStore.cartList"
					:key="index"
				>
					<div class="product-cart-details">
						<h4 class="product-title">
							<nuxt-link :to="'/product/'+ product.product_categories[0].slug  +'/' + product.slug">{{ product.name }}</nuxt-link>
						</h4>

						<span class="cart-product-info">
							<span class="cart-product-qty">{{ product.qty }}</span>
							x R{{ product.sale_price ? product.sale_price?.toFixed(2): product.price?.toFixed(2) }}
						</span>
					</div>

					<figure class="product-image-container">
						<nuxt-link
							:to="'/product/'+ product.product_categories[0].slug  +'/' + product.slug"
							class="product-image"
						>
							<img
								v-lazy="`${baseUrl}${product.pictures[0]?.formats.thumbnail.url}`"
								alt="`${product.name}`"
								:width="product.pictures[0]?.formats.thumbnail.width"
								:height="product.pictures[0]?.formats.thumbnail.height"
							/>
						</nuxt-link>
					</figure>
					<a
						href="#"
						class="btn-remove"
						title="Remove Product"
						@click.prevent="cartStore.removeFromCart({product: product})"
					>
						<i class="icon-close"></i>
					</a>
				</div>
			</div>

			<div class="dropdown-cart-total">
				<span>Total</span>

				<span class="cart-total-price">R{{ cartStore.priceTotal.toFixed(2) }}</span>
			</div>

			<div class="dropdown-cart-action">
				<nuxt-link
					to="/shop/cart"
					class="btn btn-primary"
				>View Cart</nuxt-link>
				<!-- <nuxt-link
					to="/shop/checkout"
					class="btn btn-outline-primary-2"
				>
					<span>Checkout</span>
					<i class="icon-long-arrow-right"></i>
				</nuxt-link> -->
			</div>
		</div>
		<div
			class="dropdown-menu dropdown-menu-right"
			v-else
			key="noCart"
		>
			<p class="text-center mb-0">No products in the cart.</p>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { useCartStore } from '@/stores/cart'

	const baseUrl = useRuntimeConfig().public.storageDomain;
	const cartStore = useCartStore();
	// computed: {
	// 	...mapGetters('cart', ['cartList', 'priceTotal', 'qtyTotal'])
	// },
	// methods: {
	// 	...mapActions('cart', ['removeFromCart'])
	// }
</script>